// English language pack
export default {
  // Common
  common: {
    learnMore: 'Learn More',
    viewDetails: 'View Details',
    backToTop: 'Back to Top',
    loading: 'Loading...',
    confirmSubmit: 'Confirm Submission',
    backToHome: 'Back to Home',
    backToPrevious: 'Go Back',
    category: 'Category',
    all: 'All',
    wechatQrcode: 'WeChat Official Account',
    emailAddress: 'Email Address',
    copySuccess: 'Copied Successfully',
    copy: 'Copy',
    noData: 'No Data',
    noDataDesc: 'No content available in this category',
  },

  // Language
  language: {
    zhCN: '简体中文',
    en: 'English',
    ja: '日本語',
    es: 'Español',
    fr: 'Français',
    selectLanguage: 'Select Language',
  },

  // Navigation Menu
  nav: {
    home: 'Homepage',
    aboutUs: 'About Us',
    companyIntro: 'Company Introduction',
    awardsHonors: 'Awards and Titles',
    products: 'Product Center',
    coronaryBypass: 'Coronary Artery Bypass Grafting (CABG)',
    severeHeartDisease: 'Severe Heart Disease and Extracorporeal Circulation',
    vascularIntervention: 'Vascular Intervention',
    academic: 'Academic Information',
    newProducts: 'New Products',
    clinicalRelated: 'Clinical Related',
    academicFrontier: 'Academic Frontier',
    news: 'Corporate News',
    newsExpress: 'News Express',
    awards: 'Awards',
    financingAnnouncement: 'Financing Announcement',
    contactUs: 'Contact Us',
  },

  // Home Page
  home: {
    // Banner
    bannerSlogan: 'YueWei Simplifies Clinical Thrives',
    bannerSloganHighlight: 'Simplifies',

    // Product Solutions
    productSolutions: 'Product Solutions',
    productCenter: 'Product Center',
    coronaryBypass: 'CABG',
    severeHeartDisease: 'Severe Heart Disease',
    severeHeartDiseaseAndECMO: 'Severe Heart Disease and Extracorporeal Circulation',
    severeHeartDiseaseMobile: 'Severe Heart Disease<br>& Extracorporeal Circulation',
    vascularIntervention: 'Vascular Intervention',

    // Our Vision
    ourVision: 'Our Vision',
    aboutUs: 'About Us',
    visionTitle1: 'INNOVATION',
    visionText1: 'DRIVEN BY CLINICAL NEEDS',
    visionTitle2: 'CRAFTSMANSHIP',
    visionText2: 'SHAPING A HEALTHIER FUTURE',

    // Development History
    developmentHistory: 'Development History',
    timeline: {
      year2021: 'Yuewei Medical Founded in Beijing',
      year2023_1: 'Zhongguancun High-Tech Enterprise',
      year2023_2: 'National-Level High-Tech Enterprise',
      year2023_3: 'Technology-Based SME Recognized by the Ministry of Science and Technology',
      year2024_1: 'Beijing Specialized and New SME',
      year2024_2: 'Boao Enterprise Forum Annual (Industry) Leading Enterprise',
      year2024_3: 'Beijing Fund Association <Sustainable Investment 2024 Outstanding Case>',
    },

    // Enterprise News
    newsCenter: 'News Center',
    enterpriseDynamics: 'Corporate News',
    corporateHonors: 'Corporate Honors',
    capitalDynamics: 'Capital Dynamics',
    strategicCooperation: 'Strategic Cooperation',
    newsTitle: 'Yuewei Medical Secures Nearly 100 Million RMB in Series A++ Funding to Accelerate the Full Process of Severe Coronary Heart Disease Diagnosis and Treatment',
    newsCategory: 'Financing Announcement',
    newsDate: '2025/12/07',
    newsDesc: 'Release company development, cooperation projects and important external information',

    // Academic Information
    academicInfo: 'Academic Information',
    clinicalResearch: 'Clinical Research',
    literatureInterpretation: 'Literature Interpretation',
    academicPromotion: 'Academic Promotion',
    academicTitle1: 'New Products',
    academicTitle2: 'Clinical Related',
    academicTitle3: 'Academic Frontier',
    academicDesc1: 'Redefining Speed and Precision | YueWei New Cardiac Stabilizer Officially Released',
    academicDesc2: 'AI-Driven Precision Diagnosis and Treatment for Coronary Heart Disease - Looking Forward to 2026',
    academicDesc3: 'Insights into New Global Clinical Perspectives - The 12th ICEF Grandly Opens in Beijing',
    academicDetailText: 'Focus on product-related clinical research, academic evidence and academic exchange content',
  },

  // About Us Page
  about: {
    aboutYuewei: 'About YueWei',
    mission: 'Mission',
    missionText1: 'Become a trusted partner',
    missionText2: 'in cardiovascular surgery',
    vision: 'Vision',
    visionText1: 'INNOVATION',
    visionText2: 'DRIVEN BY CLINICAL NEEDS',
    visionText3: 'CRAFTSMANSHIP',
    visionText4: 'SHAPING A HEALTHIER FUTURE',
    values: 'Values',
    valuesText1: 'Through continuous innovation,',
    valuesText2: 'we empower surgeons,',
    valuesText3: 'expand access to advanced technologies,',
    valuesText4: 'and bring new hope for life to more patients.',
    awardsAndTitles: 'Awards and Titles',
    companyIntro: 'Yuewei Medical was founded in September 2021 by cardiac surgeons from Anzhen Hospital together with senior executives from leading domestic and international medical device companies. It is a high-tech enterprise focused on the R&D, manufacturing, and sales of cardiovascular surgical medical devices. The company has been recognized as a National High-Tech Enterprise and a Beijing "Specialized and New" SME.',
    productIntro: 'Current main products are divided into three major sectors:',
    productLine1Title: 'Coronary Heart Disease Surgery Sector',
    productLine1Desc: ', with coronary blood flow meters and next-generation cardiac stabilizers as the core, deploying nearly ten surgical instruments, achieving full coverage of high-value consumables in coronary surgery;',
    productLine2Title: 'Severe Heart Disease and Extracorporeal Circulation Sector',
    productLine2Desc: ', with Yuewei\'s self-developed high-end cannula technology and materials as the core, deploying multiple domestic first products including thin-wall femoral arteriovenous cannulas and dual-lumen venous cannulas;',
    productLine3Title: 'Deep Vein Thrombosis Treatment Sector',
    productLine3Desc: ', this sector is a strategic layout that the company started through acquisitions in 2024, deploying two innovative medical devices around deep vein thrombosis treatment.',
    companyMotto: 'Since its establishment, Yuewei Medical has always adhered to the development philosophy of "Innovation stems from clinical needs, ingenuity builds a healthy future", and is committed to becoming a leader in China\'s severe cardiovascular surgical instruments.',
  },

  // Awards and Titles Page
  prize: {
    title: 'Awards and Titles',
    aboutYuewei: 'About YueWei',
    viewDetails: 'View Details',
    awards: {
      award1: {
        year: '2023',
        title: 'Zhongguancun High-Tech Enterprise',
      },
      award2: {
        year: '2023',
        title: 'National High-Tech Enterprise',
      },
      award3: {
        year: '2023',
        title: 'Technology-Based SME by Ministry of Science',
      },
      award4: {
        year: '2024',
        title: 'Beijing Specialized and New SME',
      },
      award5: {
        year: '2024',
        title: 'Boao Forum Annual Leading Enterprise',
      },
      award6: {
        year: '2024',
        title: 'Beijing Fund Association',
        subtitle: '<Sustainable Investment 2024 Outstanding Case>',
      },
    },
  },

  // Products Page
  products: {
    productDetails: 'Product Details',
    productCenter: 'Product Center',
    categories: {
      coronaryBypass: 'Coronary Bypass',
      severeHeartDisease: 'Severe Heart Disease & ECMO',
      vascularIntervention: 'Vascular Intervention',
    },
    items: {
      heartStabilizer: {
        name: 'Cardiac Stabilizer',
        code: '[Registration No.] JXYZ 20242030034',
      },
      coronaryImaging: {
        name: 'Coronary Angiography Imaging Software',
        code: '[Registration No.] JXYZ 20242210076',
      },
      endoscopeVessel: {
        name: 'Endoscopic Vessel Harvesting System*',
        code: '*This product is not yet available in China',
      },
      proximalAnastomosis: {
        name: 'Proximal Anastomosis System**',
        code: '*This product is not yet available in China',
      },
      ultrasonicFlowmeter: {
        name: 'Ultrasonic Blood Flow Meter (TTFM+ECUS)*',
        code: '*This product is not yet available in China',
      },
    },
  },

  // Product Detail Page
  productDetail: {
    productCenter: 'Product Center',
    title: 'Cardiac Stabilizer',
    subtitle: 'Modular, Multifunctional Cardiac Stabilizer',
    code: '[Registration No.] JXYZ 20242030034',
    description: 'This is the product introduction rich text content maintained in the backend. This is the product introduction rich text content maintained in the backend. This is the product introduction rich text content maintained in the backend. This is the product introduction rich text content maintained in the backend. This is the product introduction rich text content maintained in the backend. This is the product introduction rich text content maintained in the backend.',
  },

  // Contact Us Page
  contact: {
    title: 'Contact Us',
    yourName: 'Name',
    enterYourName: 'Name',
    yourPhone: 'Phone Number',
    enterYourPhone: 'Phone number',
    yourCompany: 'Company',
    enterYourCompany: 'Company',
    yourMessage: 'Message',
    enterYourMessage: 'Message',
    privacyAgreement: 'I agree to Yuewei Medical processing my personal data and declare that I have read the privacy policy',
    submitSuccess: 'Submission Successful',
    validation: {
      nameRequired: 'Please enter name',
      phoneRequired: 'Please enter phone number',
      companyRequired: 'Please enter company',
      messageRequired: 'Please enter message',
      agreeRequired: 'Please agree to the privacy policy',
    },
    companyName: 'Beijing YueWei Medical Technology Co., Ltd.',
    address: 'Huashang Creative Center, No. 18 Keyuan Road, Economic Development Zone, Daxing District, Beijing',
  },

  // News Page
  news: {
    title: 'News Announcements',
    categories: {
      all: 'All',
      newsExpress: 'News Express',
      awards: 'Awards',
      financing: 'Financing Announcements',
    },
  },

  // Academic Page
  academic: {
    title: 'Medical Innovation',
    categories: {
      all: 'All',
      newProducts: 'New Products',
      clinical: 'Clinical Related',
      frontier: 'Academic Frontier',
    },
  },

  // Footer
  footer: {
    companyName: 'Beijing YueWei Medical Technology Co., Ltd.',
    companyNameEn: 'Beijing Yuewei Medical Technology Co., Ltd',
    address: 'Address: Huashang Creative Center, No. 18 Keyuan Road, Economic Development Zone, Daxing District, Beijing',
    addressShort: 'Address: No. 18 Keyuan Road, Daxing District, Beijing',
    copyright: 'Copyright © 2025 Beijing YueWei Medical Technology Co., Ltd.',
    icp: 'ICP Filing: ',
    icpNumber: 'Jing ICP Bei 2025155672-1',
    securityNumber: 'Jing Public Network Security 11011502039384',
    medicalLicense: 'Medical Device Network Information Service Filing Number: ',
    medicalLicenseNumber: '(Jing) Online Medical Device Info Filing (2024) No. 00322',
  },
}
